<div fxLayout="column" style="padding:15px;">

  <mat-card>
    <mat-card-content fxLayout="column">
  <app-page-header *ngIf="!loadingDetails" [title]="pageTitle" action=''></app-page-header>
  <app-loading  *ngIf="isLoading"></app-loading>
  <div *ngIf="!isLoading" fxLayout="column" fxFlex fxLayoutAlign="center center center" style="margin-top:50px;">

    <div fxLayout="row" ngStyle.lt-md="width:100%;" ngStyle.gt-sm="width:55%;">
    <table>
      <tr> <td style="width:170px;"><b>Τίτλος αναφοράς:</b></td> <td>{{formTitle}}</td> </tr>
      <tr> <td style="width:170px;"><b>Ερώτηση αναφοράς:</b></td> <td>{{questionTitle}}</td> </tr>
    </table>
    </div>

    <div fxLayout="row" ngStyle.lt-md="width:100%;" ngStyle.gt-sm="width:55%; margin-top:20px;">
      <div> Η αίτηση εστάλη σε <span style="font-size:24px;">{{receivers}}</span> αποδέκτες</div>
    </div>

    <div fxLayout="column" ngStyle.lt-md="width:100%;" ngStyle.gt-sm="width:55%;" style="margin-top:70px;">
<!--      <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif"><b>{{questionTitle}}</b></div>-->

      <div fxLayout="row" fxFlex fxLayoutGap="5px">
        <div fxFlex="33" fxLayout="column" class="peopleResponse" fxLayoutAlign="center center center" fxLayoutGap="5px">
          <div fxLayout="row" class="numberedInfo">{{acceptedNumber}}</div>
          <div fxLayout="row" class="numberLabel">Αποδέχτηκαν</div>
        </div>

        <div fxFlex="33" fxLayout="column" class="peopleResponse" fxLayoutAlign="center center center" fxLayoutGap="5px">
          <div fxLayout="row" class="numberedInfo">{{deniedNumber}}</div>
          <div fxLayout="row" class="numberLabel">Απέρριψαν</div>
        </div>

        <div fxFlex="34"  fxLayout="column" class="peopleResponse" fxLayoutAlign="center center center" fxLayoutGap="5px">
          <div fxLayout="row" class="numberedInfo">{{noResponseNumber}}</div>
          <div fxLayout="row" class="numberLabel">Δεν απάντησαν</div>
        </div>
      </div>
    </div>


    <div fxLayout="column" ngStyle.lt-md="width:100%;" ngStyle.gt-sm="width:55%;" style="margin-top:40px; height:450px;">
      <div fxLayout="row" fxFlex fxLayoutGap="20px">

        <div *ngIf="!isLoading" fxLayout="column" fxFlex="50" class="info">
<!--            <app-report-details-side-info mode="0" [form]="currentForm"></app-report-details-side-info>-->
            <app-report-details-side-info mode="0" [form]="report"></app-report-details-side-info>
        </div>

        <div fxLayout="column" fxFlex="50" class="info">
          <app-bar-chart *ngIf="!isLoading" [chartInput]="chartResults" mode="consents" [chartMax]="getChartMax(chartResults)"></app-bar-chart>
        </div>

      </div>
    </div>

    <div fxLayout="column" ngStyle.lt-md="width:100%;" ngStyle.gt-sm="width:55%;" style="margin-top:40px; height:450px; overflow-y:auto;">
    <mat-tab-group>
      <mat-tab>
        <ng-template mat-tab-label>
          <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">
            Όλοι
          </div>
        </ng-template>

        <div style="margin-top:20px;">
          <app-report-details-table *ngIf="!isLoading" [uniqueId]="uniqueId" [report]="report" [questionId]="questionId" [dataSource]="allParents" state="0"></app-report-details-table>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">
            Αποδοχή
          </div>
        </ng-template>

        <div style="margin-top:20px;">
        <app-report-details-table *ngIf="!isLoading" [uniqueId]="uniqueId" [report]="report" [questionId]="questionId" [dataSource]="accepted" state="1"></app-report-details-table>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <div fxLayout="row" style="font-family: 'Century Gothic', sans-serif">
            Απόρριψη
          </div>
        </ng-template>
        <div style="margin-top:20px;">
        <app-report-details-table *ngIf="!isLoading" [uniqueId]="uniqueId" [report]="report" [questionId]="questionId" [dataSource]="denied" state="2"></app-report-details-table>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <div fxLayout="row" fxFlex style="font-family: 'Century Gothic', sans-serif">
            Σε αναμονή
          </div>
        </ng-template>
        <div style="margin-top:20px;">
        <app-report-details-table *ngIf="!isLoading" [uniqueId]="uniqueId" [report]="report" [questionId]="questionId" [dataSource]="noResponse" state="-1"></app-report-details-table>
        </div>
      </mat-tab>

    </mat-tab-group>
    </div>

    </div>
    </mat-card-content>
  </mat-card>
</div>
